import React, { useState, ReactElement } from 'react';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { Box, BoxProps } from '@mantine/core';
import { useWorkflow } from '../../../contexts/getWorkflow';

type EditComponentProps = {
  setIsEdit: () => void;
  workflow: Workflow;
};

type EditableComponentWrapperProps = {
  editComponent: (props: EditComponentProps) => ReactElement;
  displayComponent: (workflow: Workflow, onClick?: () => void) => ReactElement;
  workflow: Workflow;
  boxProps?: BoxProps;
};

export function EditableComponentWrapper({
  displayComponent,
  editComponent,
  workflow: originalWorkflow,
  boxProps,
}: EditableComponentWrapperProps) {
  const [isEdit, setIsEdit] = useState(false);
  const { getWorkflow } = useWorkflow();

  const setToEdit = () => {
    setIsEdit(true);
  };

  const workflow = getWorkflow() ?? originalWorkflow;

  if (isEdit) {
    return editComponent({
      setIsEdit: () => setIsEdit(false),
      workflow,
    });
  }
  return <Box {...boxProps}>{displayComponent(workflow, setToEdit)}</Box>;
}
